import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const t = localStorage.getItem("mobile_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

const MobileShopSuccessPage = () => {
  const [state, setState] = useState({ phase: "checking", message: "Έλεγχος πληρωμής...", orderId: null });
  const pollRef = useRef({ attempts: 0, timer: null });

  useEffect(() => {
    const pollState = pollRef.current;
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setState({ phase: "error", message: "Δεν βρέθηκε ID συνεδρίας" });
      return;
    }

    const poll = async () => {
      pollState.attempts += 1;
      try {
        const res = await axios.get(`${API}/mobile/checkout/status/${sessionId}`, { headers: getAuthHeaders() });
        const { payment_status, status, order_id } = res.data;
        if (payment_status === "paid") {
          try { localStorage.removeItem("fan_cart_v1"); } catch {}
          setState({ phase: "success", message: "Η πληρωμή ολοκληρώθηκε!", orderId: order_id });
          return;
        }
        if (status === "expired") {
          setState({ phase: "error", message: "Η συνεδρία πληρωμής έληξε." });
          return;
        }
        if (pollState.attempts >= 12) {
          setState({ phase: "error", message: "Η πληρωμή δεν επιβεβαιώθηκε. Ελέγξτε στις παραγγελίες σας." });
          return;
        }
        pollState.timer = setTimeout(poll, 2000);
      } catch (e) {
        setState({ phase: "error", message: e.response?.data?.detail || "Σφάλμα ελέγχου πληρωμής" });
      }
    };
    poll();
    return () => { if (pollState.timer) clearTimeout(pollState.timer); };
  }, []);

  const back = () => { window.location.href = "/app"; };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6 text-white" data-testid="mobile-shop-success">
      <div className="max-w-sm w-full text-center bg-[#121212] border border-[#262626] rounded-2xl p-8">
        {state.phase === "checking" && (
          <>
            <Loader2 size={48} className="mx-auto text-[#F5A623] mb-4 animate-spin" />
            <h1 className="font-['Bebas_Neue'] text-xl mb-2">{state.message}</h1>
            <p className="text-zinc-400 text-xs">Παρακαλώ μην κλείσετε την εφαρμογή.</p>
          </>
        )}
        {state.phase === "success" && (
          <>
            <CheckCircle size={56} className="mx-auto text-emerald-400 mb-4" />
            <h1 className="font-['Bebas_Neue'] text-xl mb-2">Επιτυχια!</h1>
            {state.orderId && <p className="text-zinc-400 text-xs mb-2">#{state.orderId.slice(0, 8)}</p>}
            <p className="text-zinc-500 text-xs mb-6">Σας ευχαριστούμε για την υποστήριξη!</p>
            <button onClick={back} className="w-full bg-[#F5A623] text-black font-semibold text-sm py-3 rounded-lg" data-testid="mobile-success-back">
              Επιστροφή στην εφαρμογή
            </button>
          </>
        )}
        {state.phase === "error" && (
          <>
            <XCircle size={56} className="mx-auto text-red-400 mb-4" />
            <h1 className="font-['Bebas_Neue'] text-xl mb-2">Σφαλμα</h1>
            <p className="text-zinc-400 text-xs mb-6">{state.message}</p>
            <button onClick={back} className="w-full border border-zinc-600 text-zinc-300 text-sm py-3 rounded-lg" data-testid="mobile-success-back">
              Επιστροφή στην εφαρμογή
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileShopSuccessPage;
